import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useIsAdmin } from "../../api/user-auths/is-admin";
import { useLoggedInUser, useUser } from "../../api/user-auths/login";
import { checkSubscriptionStatus } from "../../components/ScopeWrappers/helpers";
import { useMixpanelLogin } from "../../hooks/mixpanel";
import {
  resetExperienceListFilters,
  resetPersonalizationListFilters,
} from "../../store/slices/appSettings";

import { NotSubscribedRoutes } from "./notSubscribedRoutes";
import { SubscribedRoutes } from "./subscribedRoutes";

export const SkipNotSubscribedList = [
  "kenni@studio31.io",
  "member@intelligems.io",
];

export const LoggedInRoutes = () => {
  const user = useLoggedInUser();
  const dispatch = useDispatch();

  useMixpanelLogin();

  const isAdmin = useIsAdmin();
  const isSubscriptionActive = checkSubscriptionStatus(true);

  useEffect(() => {
    dispatch(resetPersonalizationListFilters());
    dispatch(resetExperienceListFilters());
  }, []);
  if (
    isSubscriptionActive !== true &&
    isAdmin === false &&
    !SkipNotSubscribedList.includes(user.data?.user?.email || "")
  ) {
    return <NotSubscribedRoutes />;
  }

  return <SubscribedRoutes />;
};
